const NETWORK_SPEAKER_MODELS = {
  AU_001: 'AU_001',
  AU_003: 'AU_003',
  AU_004: 'AU_004',
};

const TYPE = {
  NETWORK_SPEAKER: 'ipspeaker',
  POE_SWITCH: 'poeSwitch',
};

const ADD_STATUS = {
  ADDED: 'added',
  OCCUPIED: 'occupied',
};

const DEVICES = {
  [TYPE.POE_SWITCH]: {
    NAME_MAX_LENGTH: 64,
    DRM_SEARCH_MODEL: 'AW-'
  },
  [TYPE.NETWORK_SPEAKER]: {
    NAME_MAX_LENGTH: 64,
    PASSWORD_MAX_LENGTH: 15,
    DRM_SEARCH_MODEL: 'AU-00',
    MODELS: NETWORK_SPEAKER_MODELS,
    // Models allowed when the bridge device is a Camera (DRM search from camera).
    // Only AU-001 is supported for now. Use hyphenated names to match bridge RX.
    CAMERA_BRIDGE_ALLOWED_MODELS: ['AU-001'],
    MODEL_NAME: {
      [NETWORK_SPEAKER_MODELS.AU_001]: 'AU-001',
      [NETWORK_SPEAKER_MODELS.AU_003]: 'AU-003',
      [NETWORK_SPEAKER_MODELS.AU_004]: 'AU-004',
    },
    SINGLE_AUDIO_MODEL: [NETWORK_SPEAKER_MODELS.AU_001],
    MULTI_AUDIO_MODEL: [
      NETWORK_SPEAKER_MODELS.AU_003,
      NETWORK_SPEAKER_MODELS.AU_004
    ],
    DEFAULT_VOLUME: {
      [NETWORK_SPEAKER_MODELS.AU_001]: 1,
      [NETWORK_SPEAKER_MODELS.AU_003]: 50,
      [NETWORK_SPEAKER_MODELS.AU_004]: 50,
    },
    VOLUME: {
      [NETWORK_SPEAKER_MODELS.AU_001]: [
        0,
        1,
        2,
        3
      ],
      [NETWORK_SPEAKER_MODELS.AU_003]: [
        0,
        10,
        20,
        30,
        40,
        50,
        60,
        70,
        80,
        90,
        100
      ],
      [NETWORK_SPEAKER_MODELS.AU_004]: [
        0,
        10,
        20,
        30,
        40,
        50,
        60,
        70,
        80,
        90,
        100
      ],
    },
    MAX_FILE_SIZE_MEGA_BYTES: {
      [NETWORK_SPEAKER_MODELS.AU_001]: 0.375, // 384 KB
      [NETWORK_SPEAKER_MODELS.AU_003]: 4,
      [NETWORK_SPEAKER_MODELS.AU_004]: 4,
    },
    SUPPORT_FILE_FORMAT: {
      [NETWORK_SPEAKER_MODELS.AU_001]: ['wav'],
      [NETWORK_SPEAKER_MODELS.AU_003]: [
        'wav',
        'mp3',
        'mpeg',
        'opus',
        'ogg'
      ],
      [NETWORK_SPEAKER_MODELS.AU_004]: [
        'wav',
        'mp3',
        'mpeg',
        'opus',
        'ogg'
      ],
    },
    I18N: {
      VOLUME: {
        [NETWORK_SPEAKER_MODELS.AU_001]: {
          0: (t) => t('Weak'),
          1: (t) => t('Low'),
          2: (t) => t('Medium'),
          3: (t) => t('High'),
        },
      },
    },
  }
};

export default Object.freeze({
  TYPE,
  TYPE_NAME: {
    [TYPE.NETWORK_SPEAKER]: (t) => t('Network speaker'),
    [TYPE.POE_SWITCH]: (t) => t('PoE Switch'),
  },
  ICON: {
    [TYPE.NETWORK_SPEAKER]: 'general_speaker_solid',
    [TYPE.POE_SWITCH]: 'general_poe_solid',
  },
  DEVICES,
  ADD_STATUS,
  ADD_STATUS_LABEL: {
    [ADD_STATUS.ADDED]: (t) => t('Added'),
    [ADD_STATUS.OCCUPIED]: (t) => t('Occupied'),
  },
  ADD_STEPS: {
    SELECT_DEVICE: 'SELECT_DEVICE',
    SEARCH: 'SEARCH',
  },
  ADD_DEVICE_ERROR: {
    DEVICE_ERROR: {
      AUTH_FAILED: 'Unauthorized',
      TIMEOUT: 'Timeout',
      NOT_FOUND: 'Not found',
    },
    SERVER_MESSAGE: {
      /** From server: "Device already added to another org" */
      IN_ANOTHER_ORGANIZATION: 'in another organization'
    },
  },
});
